import i18n from '@/i18n';

const healthLogMetricFields = {
  systolic: i18n.t('Systolic'),
  diastolic: i18n.t('Diastolic'),
  pulse: i18n.t('Pulse'),
  saturation: i18n.t('Saturation'),
  glucose: i18n.t('Glucose'),
  temperature: i18n.t('Temperature'),
  weight: i18n.t('Weight'),
  volume: i18n.t('Volume'),
} as Record<string, string>;

export default healthLogMetricFields;
